module.exports = __webpack_public_path__ + "img/product_48.526997f.svg";